module.exports = __webpack_public_path__ + "img/ordermanagement.6f515802.svg";